import styled from '@emotion/styled';

export const Submenu = styled.div`
`;
